import { useEffect, useState } from "react";
import UserProductService from "../../services/user/UserProductService";

export default function useUserProductDetail(slug) {
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) return;

        let isMounted = true;

        async function fetchProduct() {
            try {
                setLoading(true);
                setError(null);
                const res = await UserProductService.getProductBySlug(slug);

                if (!isMounted) return;

                setProduct(res.data.data || null);
            } catch (err) {
                if (isMounted) setError(err);
            } finally {
                if (isMounted) setLoading(false);
            }
        }

        fetchProduct();

        return () => {
            isMounted = false;
        };
    }, [slug]);

    return {
        product,
        loading,
        error,
    };
}
